import { pluralize } from 'humanize-plus'
import { Creatable } from 'react-select-plus'
import IconSVG from 'svg-inline-react'
import { Link } from 'react-router'
import { List } from 'immutable'

import Avatar from 'shared-web/src/components/Avatar'
import Tag from 'shared-web/src/components/Tag'

import Editor from '../Editor'
import ActionError from '../ActionError'
import Action from '../Action'
import Card from '../Card'

import styles from './style.styl'

import minusIconSrc from '!svg-inline?removeTags=true!images/svg/minus.svg'

const LEADBOT_QUALIFIED_OPTION = {
  label: 'LeadBot Qualified',
  value: 'LEADBOT_QUALIFIED',
}

class Goal extends React.Component {
  render() {
    const { 
      goal,
      classificationDetails,
      classificationOptions,
      onClassificationChange,
      onNewClassificationClick,
      onMessageActionBodyChange,
      onAddActionClick,
      onEditActionClick,
      onDeleteActionClick,
      onGoalDeleteClick,
      onEditRoutingClick,
      isGlobalRouting,
      isSingleRouting,
      isGroupRouting,
      isNoRouting,
      isMessage,
      isCQL,
      isScheduling,
      isStatusChange,
      isLastGoal,
      singleRoutingTargetUser,
      groupRoutingTargetUsers,
      usersForRules,
      singleRoutingInvalidUsers,
      globalRoutingInvalidUsers,
      isCaptureTypePlaybook,
      isCtaTypePlaybook,
      isChatTypePlaybook,
      isOutboundPlaybook,
      isABMPlaybook,
      hasRoutingAction,
      isMeetingCta,
      cqlScore,
      copy,
    } = this.props

    const defaultClassificationOption = !!classificationDetails
      ? classificationOptions.find(c => c.value === classificationDetails.value) || LEADBOT_QUALIFIED_OPTION
      : _.head(classificationOptions)
    const groupRoutingDisplayUsers = groupRoutingTargetUsers ? List(groupRoutingTargetUsers.slice(0, 8)) : List()
    const numRoutingUsersLeft = groupRoutingTargetUsers
      ? List(groupRoutingTargetUsers).size - groupRoutingDisplayUsers.size
      : 0

    return (
      <div key={goal.id} className={styles.Goal}>
        <header className="playbook-title-header">
          <h2>Create a Goal for this Playbook.</h2>
          <p>{copy}</p>
        </header>
        <Card
          className="drift-form goal-card"
          title="Goal"
          description={_.get(classificationDetails, 'label', '...')}
          onDeleteClick={!isLastGoal && onGoalDeleteClick}
        >
          <div className="goal-action goal-classification-content">
            <div className="goal-action-label">What is the Lead Stage tied to this goal?</div>
            <Creatable
              placeholder="Enter Lead Stage (required)"
              value={defaultClassificationOption}
              options={classificationOptions}
              onChange={onClassificationChange}
              onNewOptionClick={onNewClassificationClick}
              clearable={false}
              valueRenderer={option => (
                <Tag className="classification-tag" tag={{ name: option.label }} />
              )}
            />
          </div>
          {isCtaTypePlaybook && (
            <Action label="What criteria should trigger this goal?">Lead clicked CTA</Action>
          )}
          {(isChatTypePlaybook || isOutboundPlaybook || isABMPlaybook) && (
            <Action label="What criteria should trigger this goal?">
              Lead starts a Conversation
            </Action>
          )}
          {isCaptureTypePlaybook && (
            <Action label="What criteria should trigger this goal?">Submitted Email</Action>
          )}
          {isABMPlaybook && (
            <Action label="Route Conversation">
              <p>This conversation will route to Account Owner for this contact.<br /><a href="/accounts">View your team&apos;s accounts</a></p>
            </Action>
          )}
          {isOutboundPlaybook && (
            <Action label="Route Conversation">
              <p>This conversation will route to the teammate who sent the Drift Tracked email</p>
            </Action>
          )}
          {isMeetingCta &&
            <Action label="Route Conversation">
              <p>Routing for the purpose of scheduling meetings is available with <a href="/marketplace/playbooks/BOOK_MORE_MEETINGS" target="_blank">DriftBot</a></p>
            </Action>
          }
          {!isOutboundPlaybook && !isABMPlaybook && !isMeetingCta &&
          hasRoutingAction && (
            <Action label="Route Conversation" onEditClick={onEditRoutingClick}>
              {isNoRouting && (
                <p>
                  none -{' '}
                  <span className="edit-routing-rules-link" onClick={onEditRoutingClick}>
                    set up now
                  </span>
                </p>
              )}
              {isSingleRouting &&
              !!singleRoutingTargetUser && (
                <div className="flex">
                  {singleRoutingTargetUser.avatarUrl && (
                    <Avatar size="small" user={singleRoutingTargetUser} />
                  )}
                  <p>{singleRoutingTargetUser.name}</p>
                </div>
              )}
              {isGlobalRouting && (
                <div>
                  <p>Route lead based on your Lead Routing rules.</p>
                  <div className="flex">
                    {usersForRules &&
                      usersForRules.map(
                        user => user && <Avatar key={user} size="small" user={user} />
                      )}
                  </div>
                </div>
              )}
              {isGroupRouting && (
                <div className="flex">
                  <p className="routing-option-title">Round robin between: </p>
                  <div className="flex routing-option-value-container">
                    {groupRoutingTargetUsers &&
                      groupRoutingDisplayUsers.map(
                        user =>
                          user && (
                            <div key={user} className="flex routing-option">
                              <Avatar size="small" user={user} />
                            </div>
                          )
                      )}
                    {numRoutingUsersLeft > 0 && (
                      <p className="more-users-label">+{numRoutingUsersLeft} more</p>
                    )}
                  </div>
                </div>
              )}
            </Action>
          )}
          {isMessage && (
            <Action label="Send Message" onDeleteClick={onDeleteActionClick.bind(this, 'message')}>
              <p>
                Create a special message to end the bot conversation for contacts who hit this goal.
              </p>
              <Editor value={goal.message.get('body')} onChange={onMessageActionBodyChange} noPersonalization={true} />
            </Action>
          )}
          {isScheduling && (
            <Action label="Send Calendar" onDeleteClick={onDeleteActionClick.bind(this, 'schedule')}>
              <p>Calendar will be sent based on the routing chosen above.</p>
            </Action>
          )}
          {isCQL && (
            <Action
              label="Mark as CQL"
              onEditClick={onEditActionClick.bind(this, 'markCQL')}
              onDeleteClick={onDeleteActionClick.bind(this, 'markCQL')}
            >
              {cqlScore === -1 && (
                <p>
                  <IconSVG title="Unqualified" className="cql-bar-minus-icon" src={minusIconSrc} />
                </p>
              )}
              {cqlScore > 0 && <p>{_.times(cqlScore, () => `⚡`)}</p>}
            </Action>
          )}
          {isStatusChange && (
            <Action
              label="Auto-close Conversation"
              onDeleteClick={onDeleteActionClick.bind(this, 'statusChange')}
            >
              <p>Conversations will be automatically closed in inbox.</p>
            </Action>
          )}
          {isSingleRouting &&
          singleRoutingInvalidUsers().length > 0 && (
            <ActionError>
              <p>
                You have a schedule action, but the agent in your Single Routing rule ({singleRoutingInvalidUsers().map(
                  user => {
                    return user && (user.name || user.email)
                  }
                )}) does not have their calendar connected. If a lead gets routed to them, the bot
                will not send a calendar.
              </p>
            </ActionError>
          )}
          {isGlobalRouting &&
          globalRoutingInvalidUsers().length > 0 && (
            <ActionError>
              <div>
                <p>
                  {globalRoutingInvalidUsers().length}{' '}
                  {pluralize(globalRoutingInvalidUsers().length, 'agent')} in your Lead Routing rules
                  do not have their calendars connected. If a lead gets routed to them, the bot will
                  not send a calendar. They can connect their calendar{' '}
                  <a href="/meetings" target="_blank">
                    here.
                  </a>
                </p>
                <p>
                  ({globalRoutingInvalidUsers()
                    .map(user => user.name || user.email)
                    .join(', ')})
                </p>
              </div>
            </ActionError>
          )}
          {isNoRouting &&
          isScheduling && (
            <ActionError>
              <p>
                You have a schedule action selected, but no routing rules applied. If a lead triggers
                this goal, the bot will not send a calendar.
              </p>
            </ActionError>
          )}
          <button
            className="drift-button drift-button-secondary goal-action-add-button"
            onClick={onAddActionClick}
          >
            Add Action
          </button>
        </Card>
      </div>
    )
  }
}

export default Goal



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/Goal/component.js